export const getTeamPlan = team => team?.plan

export const getTeamIsOnTrial = team => {
    if (!team || !team.subscription_status) {
        return null;
    }

    return team.subscription_status === 'trialing';
}

export const getSubscriptionPrice = (planDetails, discount) => {
    if (!planDetails) {
        return 0;
    }

    let subtotal = 0;
    const monthly = planDetails.billing_period === 'month';

    if (planDetails.price_per_user) {
        subtotal = planDetails.price_per_user * (monthly ? 1 : 12) * planDetails.quantity;
    } else {
        subtotal = planDetails.total * (monthly ? 1 : 12);
    }
    // const subtotal = planDetails.total * planDetails.quantity;

    if (discount?.coupon) {
        if (discount.coupon.percent_off) {
            return subtotal - (subtotal * (discount?.coupon?.percent_off / 100));
        } else if (discount.coupon.amount_off) {
            return subtotal - discount.coupon.amount_off;
        }
    }

    return subtotal;
}
